// extracted by mini-css-extract-plugin
export var homeContainer = "home-module--homeContainer--dnH+E";
export var homeLogo = "home-module--homeLogo--+5+ka";
export var artistValues = "home-module--artistValues--AHFQB";